import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ff06452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { useIMask, IMask } from 'vue-imask';
    import { computed, toRef } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ApTime',
  props: {
        modelValue: [String, Array],
        validateOnBlur: {
            type: Boolean,
            default: true,
        },
        width: {
            type: [String, Number],
            default: 100,
        },
        range: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
  emits: ['input:modelValue', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

    

    
    const modelValue = toRef(props, 'modelValue');

    const widthInner = computed(() => {
        var w = props.width;
        if (!w) return null;
        if (Number(w) == w) {
            return `${w}px`;
        }
        return w;
    });
    function onAccept() {
        if (props.range) {
            emit(
                'input:modelValue',
                masked.value.split('-').map((x: string) => x.trim())
            );
        } else {
            emit('input:modelValue', masked.value);
        }
    }
    function onComplete() {
        if (props.range) {
            emit(
                'update:modelValue',
                masked.value.split('-').map((x: string) => x.trim())
            );
        } else {
            emit('update:modelValue', masked.value);
        }
    }
    function onClear() {
        if (props.range) {
            emit('update:modelValue', []);
        } else {
            emit('update:modelValue', '');
        }
    }
    const { el, masked } = useIMask(
        {
            alias: props.range ? 'hh:mm - hh:mm' : 'hh:mm',
            mask: props.range ? 'hh:mm - hh:mm' : 'hh:mm',
            lazy: false,

            blocks: {
                hh: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 23,
                },

                mm: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                },
            },
        },
        {
            onAccept,
            onComplete,
            onClear,
        }
    );
    function onBlur() {
        const current = masked.value;
        if (!props.validateOnBlur) return;
        if (!current || current.includes('_')) {
            masked.value = props.modelValue;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "el",
      ref: el,
      class: "ap-input",
      style: _normalizeStyle({ width: widthInner.value }),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      onBlur: onBlur
    }, null, 36), [
      [_vModelText, modelValue.value]
    ]),
    (__props.clearable)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: onClear,
          class: "ap-icon-fail2NEw remove-btn"
        }, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})